import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DataTransferService } from './data-transfer.service';
import { FormDataService } from './form-data.service';
import { ToastService } from '@siemens/ix-angular';
import { ValidationFeedback } from 'src/const-data/validation-feedback';
import { map, Observable, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(
    private readonly formDataService: FormDataService,
    private readonly dataTransferService: DataTransferService,
    private readonly toastService: ToastService
  ) {}

  readData(form: FormGroup, projectId: string): Observable<void> {
    const keysFromDialog = this.formDataService.getFormControlKeysArray(form);

    return this.dataTransferService.getValuesFromExcel(keysFromDialog, projectId).pipe(
      tap(formData => {
        this.formDataService.fillDataIntoDialog(form, formData);
      }),
      map(() => void 0)
    );
  }

  tryWriteData(form: FormGroup, projectId: string): Observable<boolean> {
    if (form.valid) {
      const changedValuesToWrite = this.formDataService.getDataFromDialog(form);
      return this.dataTransferService.writeDataToExcel(changedValuesToWrite, projectId).pipe(map(() => true));
    } else {
      this.toastService.show({
        title: 'Invalid input',
        message: ValidationFeedback.invalidForm,
        type: 'error'
      });
      return of(false);
    }
  }
}
